<template>
  <div id="app">
    <div class="tab">
     <!-- <ul>
        <li><span class="active">证据固化预约</span></li>
        <li><span>预约进度</span></li>
      </ul>-->
       <h3 @click="back" style="border-bottom:1px solid #ccc;padding:0px 0 10px 10px;cursor:pointer">返回</h3>
    <!--  <div class="btn">
        <button class="local">本地预约(深圳)</button>
        <button class="ecdemic active">外地预约(深圳外)</button>
      </div>-->
    </div>
    <div class="info">
      <div class="left">
        <el-form ref="formValidate" :rules="rules" :model="ruleForm" >
          <div class="lable">检索项目名称</div><br/><br/>
          <el-form-item label="固化标题：" prop="title"><el-input v-model="ruleForm.title" placeholder="固化标题"></el-input></el-form-item>
        
          <el-form-item label="申请人：" prop="applicant"><el-input v-model="ruleForm.applicant" placeholder="申请人"></el-input></el-form-item>
          <el-form-item label="联系方式：" prop="tel"><el-input v-model="ruleForm.tel" type="text" placeholder="联系方式:"></el-input></el-form-item>
          <el-form-item label="城市：" prop="city"><el-input v-model="ruleForm.city" type="text" placeholder="城市"></el-input></el-form-item>
          <el-form-item label="申请日期：" prop="apply_date">
            <el-date-picker
              v-model="ruleForm.apply_date"
              type="date"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <div class="count">共{{totlaCount}}个</div>
        <div class="btn">
          <button @click="apply">确认申请</button>
        </div>
      </div>
      <div class="clear_both"></div>
    </div>
  
        
    <div v-if="guhuaWeb" class="result">
      <div class="title">{{guhuaWeb.title}}（{{guhuaWeb.count}}个）</div>
      <ul>
        <li v-for="(item,key) in guhuaWeb.list" :key="key">
          <img :src="item.targetPic"/>
          <div class="link">{{item.targetLink}}</div>
          <div class="clear_both"></div>
        </li>
      
      </ul>
    </div>

            
    <div v-if="guhuaBuy" class="result">
      <div class="title">{{guhuaBuy.title}}（{{guhuaBuy.count}}个）</div>
      <ul>
        <li v-for="(item,key) in guhuaBuy.list" :key="key">
          <img :src="item.targetPic"/>
          <div class="link">{{item.targetLink}}</div>
          <div class="clear_both"></div>
        </li>
      
      </ul>
    </div>

            
    <div v-if="guhuaRec" class="result">
      <div class="title">{{guhuaRec.title}}（{{guhuaRec.count}}个）</div>
      <ul>
        <li v-for="(item,key) in guhuaRec.list" :key="key">
          <img :src="item.targetPic"/>
          <div class="link">{{item.targetLink}}</div>
          <div class="clear_both"></div>
        </li>
      
      </ul>
    </div>
  </div>
 
</template>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Appointment.css"></style>

<script>
import {getResultApi,addAppointmentApi} from '@/service/allApi'
export default {
  data(){
    return {
      guhuaWeb:null,
      guhuaBuy:null,
      guhuaRec:null,
      totlaCount:0,
      ruleForm:{
        title:"",
        applicant:"",
        tel:"",
        city:"",
        guhua_web:"",
        guhua_buy:"",
        guhua_receive:"",
        apply_date:"",
      },
      rules:{
        title:{required: true, message: '申请人不能为空', trigger: 'blur'},
        applicant:{required: true, message: '申请人不能为空', trigger: 'blur'},
        tel:{required: true, message: '联系人电话能能为空', trigger: 'blur'},
        city:{required: true, message: '城市不能为空', trigger: 'blur'},
        apply_date:{required: true, message: '请选择申请时间', trigger: 'blur'},
      }

    }
  },

  mounted(){
    this.ruleForm.guhua_web = this.$route.query.w
    this.ruleForm.guhua_buy = this.$route.query.b
    this.ruleForm.guhua_receive = this.$route.query.r
    const p1 = {
      rids : this.ruleForm.guhua_web
    }
    getResultApi(p1).then((res)=>{
      // console.log(res)
      if(res.data.code == 100 && res.data.list.length > 0){
        this.totlaCount = this.totlaCount + res.data.list.length
        this.guhuaBuy = {
          "title":"网页固化",
          "count":res.data.list.length,
          "list":res.data.list
        }
      }
    })

    const p2 = {
      rids : this.ruleForm.guhua_buy
    }
    getResultApi(p2).then((res)=>{
      //  console.log(res)
       if(res.data.code == 100 && res.data.list.length > 0){
         this.totlaCount = this.totlaCount + res.data.list.length
        this.guhuaWeb = {
          "title":"购买固化",
           "count":res.data.list.length,
          "list":res.data.list
        }
      }
    })

     const p3 = {
      rids : this.ruleForm.guhua_receive
    }
    getResultApi(p3).then((res)=>{
      //  console.log(res)
       if(res.data.code == 100 && res.data.list.length > 0){
         this.totlaCount = this.totlaCount + res.data.list.length
        this.guhuaRec = {
          "title":"收货固化",
           "count":res.data.list.length,
          "list":res.data.list
        }
      }
    })


  },
  methods:{
    apply(){
      var that = this
       this.$refs['formValidate'].validate((valid)=>{
         if(valid){
           addAppointmentApi(that.ruleForm).then((res)=>{
             if(res.data.code == 100){
               alert("预约成功");
               window.parent.toUrl("/my?page=appointmentprocess");
             }
           })
         }
       })
    },

    back(){
      window.history.go(-1)
    },

  }
}
</script>


// WEBPACK FOOTER //
// src/components/iframe/Appointment.vue